class FAQItem extends HTMLElement {
  constructor() {
    super();
    this.targetId = this.dataset.target;
    this.sideMenuItem = null;
    this.menuItemClass = 'digital-category__side-menu-item';
    this.observer = null;
    this.isClickDelayed = false;
  }

  connectedCallback() {
    this.setupSideMenuItem();
    this.setupObserver();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  setupSideMenuItem() {
    this.sideMenuItem = document.querySelector(`.${this.menuItemClass}[data-target="${this.targetId}"]`);
    if (this.sideMenuItem) {
      this.sideMenuItem.addEventListener('click', this.handleMenuItemClick.bind(this));
    } else {
      console.warn(`Side menu item for target "${this.targetId}" not found.`);
    }
  }

  setupObserver() {
    const targetElement = document.getElementById(this.targetId);

    if (targetElement) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.setActiveMenuItem(this.sideMenuItem);
          }
        });
      }, { threshold: 0.5 });

      this.observer.observe(targetElement);
    } else {
      console.error(`Target element with ID "${this.targetId}" not found for observing.`);
    }
  }

  cleanup() {
    if (this.sideMenuItem) {
      this.sideMenuItem.removeEventListener('click', this.handleMenuItemClick.bind(this));
    }
    if (this.observer) {
      const targetElement = document.getElementById(this.targetId);
      if (targetElement) {
        this.observer.unobserve(targetElement);
      }
    }
  }

  handleMenuItemClick(event) {
    event.preventDefault();
    this.setActiveMenuItemWithDelay(this.sideMenuItem);
    this.scrollToTarget();
  }

  setActiveMenuItemWithDelay(selectedItem) {
    if (this.isClickDelayed) return;

    this.isClickDelayed = true;

    setTimeout(() => {
      this.setActiveMenuItem(selectedItem);
      this.isClickDelayed = false;
    }, 500);
  }

  setActiveMenuItem(selectedItem) {
    const allMenuItems = document.querySelectorAll(`.${this.menuItemClass}`);
    allMenuItems.forEach((item) => item.classList.remove('active'));

    if (selectedItem) {
      selectedItem.classList.add('active');
    }
  }

  scrollToTarget() {
    const targetElement = document.getElementById(this.targetId);
    const headerHeight = this.getHeaderHeight();

    if (targetElement) {
      const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
      this.performSmoothScroll(targetPosition);
    } else {
      console.error(`Target element with ID "${this.targetId}" not found.`);
    }
  }

  getHeaderHeight() {
    const header = document.querySelector('.main-header-top');
    return header ? header.offsetHeight : 0;
  }

  performSmoothScroll(position) {
    window.scrollTo({
      top: position,
      behavior: 'smooth',
    });
  }
}

customElements.define('faq-item', FAQItem);
